<template>
  <Modal title="Upload From Urls" showModal @submit="submit">
    <template v-slot:body>
      <div class="main-content">
        <textarea class="form-control" rows="10" placeholder="Enter url here" v-model="data"></textarea>
      </div>
    </template>
    <template v-slot:footer></template>
  </Modal>
</template>

<script>
import Modal from '@/components/BaseModal.vue'
export default {
  components: {
    Modal
  },
  data() {
    return {
      data: ''
    }
  },
  computed: {
    urls() {
      return this.$util.filter(this.data.split(/[,|\\|\r?\n]/g), ({ item }) => {
        return this.isValidHttpUrl(item)
      })
    }
  },
  methods: {
    isValidHttpUrl(string) {
      let url
      try {
        url = new URL(string)
      } catch {
        return false
      }
      return url.protocol === 'http:' || url.protocol === 'https:'
    },
    submit() {
      if (_.isFunction(this.config?.callback)) {
        this.config?.callback(Object.values(this.urls))
      }
      this.$emit('close')
    }
  },
  props: {
    config: Object
  }
}
</script>
